import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Card, CardContent, Tab, Tabs } from '@mui/material';
import { endpoints, qk } from '../api/endpoints';
import { AlertList } from '../components/AlertList';
import { ErrorState, PageHeader, SkeletonRows } from '../components/common';

export function AlertsPage() {
  const [tab, setTab] = useState<'open' | 'resolved'>('open');
  const open = tab === 'open';
  const q = useQuery({ queryKey: qk.alerts(open), queryFn: () => endpoints.alerts({ open }), refetchInterval: 30_000 });
  return (
    <>
      <PageHeader title="Alerts" subtitle="Opened and resolved automatically by the collector; Telegram is notified on both." />
      <Tabs value={tab} onChange={(_, v) => setTab(v)} sx={{ mb: 2 }}>
        <Tab value="open" label="Open" />
        <Tab value="resolved" label="Resolved" />
      </Tabs>
      {q.isError && <ErrorState error={q.error} onRetry={() => void q.refetch()} />}
      <Card>
        <CardContent>{q.isLoading ? <SkeletonRows rows={4} height={56} /> : <AlertList alerts={q.data ?? []} emptyTitle={open ? undefined : 'No resolved alerts yet'} />}</CardContent>
      </Card>
    </>
  );
}
